import * as React from 'react'

function SvgFunArrowTriangleUp(props: React.SVGProps<SVGSVGElement>) {
  return (
    <svg viewBox="0 0 24 24" fill="currentColor" {...props}>
      <path d="M11.5 15.667h-5a.5.5 0 01-.4-.8l2.4-3.2L11.1 8.2a.5.5 0 01.8 0l2.6 3.467 2.4 3.2a.5.5 0 01-.4.8h-5z" />
    </svg>
  )
}

export default SvgFunArrowTriangleUp
